export const problems = [
  {
    id: 1,
    title: 'No saber qué vestir',
    description:
      'El 73% de los profesionales pierde más de 15 minutos diarios decidiendo su atuendo. Esa indecisión genera estrés y afecta la primera impresión que proyectas ante clientes, colegas y socios.',
  },
  {
    id: 2,
    title: 'Pérdida de tiempo',
    description:
      'Compras impulsivas, prendas sin estrenar, armarios desorganizados. El desperdicio económico y temporal es considerable, y el resultado sigue siendo insatisfactorio.',
  },
  {
    id: 3,
    title: 'Imagen incoherente',
    description:
      'Vestir diferente cada día sin una línea definida transmite inseguridad. Tu imagen debe ser un activo estratégico, no una variable aleatoria que dependa del estado de ánimo.',
  },
  {
    id: 4,
    title: 'Falta de identidad estética',
    description:
      'Sin un criterio propio, las tendencias dictan tu armario. Necesitas un estilo que te represente, que comunique quién eres antes de que abras la boca.',
  },
];

export const benefits = [
  {
    id: 1,
    title: 'Ahorro de tiempo',
    description:
      'Tu armario organizado, tus looks planificados. Decisiones de imagen resueltas en segundos, no en minutos de indecisión cada mañana.',
    icon: 'ri-time-line',
  },
  {
    id: 2,
    title: 'Seguridad personal',
    description:
      'Sabes exactamente qué ponerte y por qué. Cada elección refuerza tu presencia y proyecta la confianza que necesitas en cada contexto.',
    icon: 'ri-shield-check-line',
  },
  {
    id: 3,
    title: 'Imagen alineada con objetivos',
    description:
      'Tu vestuario se convierte en una herramienta estratégica. Cada look está pensado para el contexto profesional, social o personal que vas a enfrentar.',
    icon: 'ri-focus-3-line',
  },
  {
    id: 4,
    title: 'Optimización del armario',
    description:
      'Menos prendas, más combinaciones. Eliminamos lo superfluo y maximizamos el potencial de cada pieza que conservas, reduciendo compras innecesarias.',
    icon: 'ri-stack-line',
  },
];

export const steps = [
  {
    id: 1,
    number: '01',
    title: 'Evaluación profunda',
    description:
      'Analizamos tu perfil psicológico, estilo de vida, objetivos profesionales y sociales, y tu relación actual con la imagen personal.',
  },
  {
    id: 2,
    number: '02',
    title: 'Diagnóstico del armario',
    description:
      'Auditoría completa de tu vestuario actual. Identificamos huecos, redundancias, piezas clave y lo que debe desaparecer definitivamente.',
  },
  {
    id: 3,
    number: '03',
    title: 'Definición estratégica',
    description:
      'Creamos tu paleta de color, siluetas favorables, códigos de vestuario por contexto y la arquitectura de tu nuevo armario ideal.',
  },
  {
    id: 4,
    number: '04',
    title: 'Sistema digital activo',
    description:
      'Registramos tus prendas en la plataforma. Configuramos combinaciones inteligentes, calendario de looks y recomendaciones semanales.',
  },
  {
    id: 5,
    number: '05',
    title: 'Transformación física',
    description:
      'Asesoría en cabello, barba, piel y definición estética completa. Complementamos el armario con prendas diseñadas a medida si es necesario.',
  },
  {
    id: 6,
    number: '06',
    title: 'Seguimiento continuo',
    description:
      'Revisamos evolución, ajustamos el sistema y aseguramos que tu imagen crezca contigo. El estilo es un proceso, no un destino fijo.',
  },
];

export const digitalFeatures = [
  {
    id: 1,
    title: 'Registro total de prendas',
    description:
      'Cada pieza de tu armario catalogada con foto, categoría, color, ocasión y frecuencia de uso real.',
    icon: 'ri-t-shirt-line',
  },
  {
    id: 2,
    title: 'Control de uso inteligente',
    description:
      'El sistema identifica qué prendas usas y cuáles permanecen olvidadas, optimizando cada inversión que hiciste.',
    icon: 'ri-bar-chart-grouped-line',
  },
  {
    id: 3,
    title: 'Combinaciones automáticas',
    description:
      'Algoritmo basado en criterios de Anthony Sánchez que propone looks coherentes según tu agenda y el clima previsto.',
    icon: 'ri-magic-line',
  },
  {
    id: 4,
    title: 'Recomendaciones personalizadas',
    description:
      'Alertas de huecos en el armario, sugerencias de compra estratégica y notas de estilo enviadas semanalmente.',
    icon: 'ri-lightbulb-line',
  },
  {
    id: 5,
    title: 'Calendario de looks',
    description:
      'Planifica qué vestir con anticipación. Looks asignados a reuniones, eventos, viajes y día a día sin improvisaciones.',
    icon: 'ri-calendar-event-line',
  },
];

export const plans = [
  {
    id: 1,
    name: 'Esencial',
    price: '1.200€',
    period: 'por temporada',
    description:
      'Revisión completa de armario y definición de estilo base para quien quiere empezar con firmeza.',
    features: [
      'Análisis de perfil psicológico y comunicación personal',
      'Revisión del armario actual (hasta 60 prendas)',
      'Definición de paleta de color personal',
      'Creación de 12 looks estratégicos',
      'Lista de compras prioritaria',
      '1 sesión de seguimiento (2h)',
    ],
    cta: 'Reservar consulta',
    highlighted: false,
  },
  {
    id: 2,
    name: 'Premium',
    price: '3.800€',
    period: 'por temporada',
    description:
      'Transformación integral con sistema digital y asesoría continua. El equilibrio perfecto.',
    features: [
      'Todo lo incluido en Esencial',
      'Acceso al sistema digital de armario inteligente',
      'Registro digital de todas las prendas',
      'Combinaciones inteligentes automatizadas',
      'Calendario de looks planificado',
      'Asesoría en corte de cabello y barba',
      'Protocolo de cuidado de piel personalizado',
      '4 sesiones de seguimiento (8h total)',
      'Personal shopper acompañado (4h)',
    ],
    cta: 'Solicitar evaluación',
    highlighted: true,
  },
  {
    id: 3,
    name: 'Integral',
    price: '7.500€',
    period: 'anual',
    description:
      'Acompañamiento completo durante un año. Tu imagen, evolucionada bajo supervisión directa.',
    features: [
      'Todo lo incluido en Premium',
      'Diseño y confección de 3 prendas a medida',
      'Organización mensual del armario',
      'Actualización continua del sistema digital',
      'Asesoría en maquillaje y definición estética',
      'Planificación de looks para eventos especiales',
      'Sesiones trimestrales de revisión (12h total)',
      'Personal shopper ilimitado dentro del plan',
      'Línea directa con Anthony Sánchez',
    ],
    cta: 'Entrevista exclusiva',
    highlighted: false,
  },
];